import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService, NotificationService } from '../services';
import { captureSentryException } from '../services/error.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private notification: NotificationService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        this.captureErrorForSentry(request.url, error, HttpStatusCode.InternalServerError);
        switch (error.status) {
          case HttpStatusCode.Unauthorized:
          case HttpStatusCode.InternalServerError:
            if (this.authenticationService.activeSession()) {
              this.authenticationService.logout();
              this.notification.displayError('Please login again.', 'Session Expired');
            }
            break;

          case HttpStatusCode.Forbidden:
            this.notification.displayError('Please Contact Support.', 'Permission Denied');
            break;

          case HttpStatusCode.NotFound:
            this.notification.displayError('Please Contact Support', 'Error - Not Found');
            break;

          default:
            break;
        }

        const errorOutput = (error && error?.error?.errors) || error.message;
        return throwError(errorOutput);
      }),
    );
  }

  captureErrorForSentry(requestURL: string, errorMessage: string, errorStatusCode: HttpStatusCode) {
    captureSentryException({
      requestURL,
      errorMessage,
      pageURL: location.href,
      errorStatusCode,
      timestamp: new Date().toUTCString(),
    });
  }
}
